import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="nf-page">
      <nav className="nf-nav">
        <Link to="/" className="nf-nav-logo">LottoPickle</Link>
      </nav>

      <div className="nf-content">
        <div className="nf-balls">
          <div className="nf-ball">4</div>
          <div className="nf-ball nf-ball-zero">0</div>
          <div className="nf-ball">4</div>
        </div>
        <h1 className="nf-title">Page not found</h1>
        <p className="nf-sub">Those numbers didn't hit. This page doesn't exist.</p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn-primary">Back to home</Link>
          <Link to="/app" className="nf-btn-secondary">Open the app</Link>
        </div>
      </div>
    </div>
  );
}
